export default __webpack_public_path__ + "static/media/mainImage4.ea782787.jpg";